export const ESTADO_CREADA = 1
export const ESTADO_PUBLICADA = 2
export const ESTADO_PAUSADA = 3
export const ESTADO_ELIMINADA = 4
export const ESTADO_VENCIDA = 5
export const ESTADO_SIN_PAGAR = 6

export const DIAS_AVISO_VENCIMIENTO = 3

export const COBRO_POR_PUBLICAR = 'P'
export const COBRO_POR_VENTA = 'V'

export const esCobroPorPublicar = ({ tipoCobro } = {}) => tipoCobro === COBRO_POR_PUBLICAR

export const SIN_PREGUNTAS_TEXTO = 'Esta publicación aún no tiene preguntas.'

export const VIGENCIA_POR_AVISO_TEXTO =
  'La vigencia de esta publicación está definida por el aviso contratado, por lo que la lista de ventas no modificará sus fechas.'

export const EXPOSICION_CON_VENTAS_TEXTO =
  'No se puede cambiar la exposición de una publicación con ventas.'

export const EXPOSICION_VIGENTE_TEXTO =
  'Para cambiar la exposición esperá al vencimiento de la publicación o modificá su estado a Vencida.'

export const VENCER_REQUIERE_REABONAR_TEXTO =
  'Al pasar la publicación a Vencida deberás abonar un nuevo aviso para volver a publicarla.'

export const COSTO_POR_PUBLICAR_TEXTO = 'Costo por publicar'
export const COMISION_POR_VENTA_TEXTO = '% de comisión por venta'
export const VIGENCIA_MENSUAL_TEXTO = 'por mes'
export const COMISION_PRESUPUESTO_TEXTO =
  'Los porcentajes de las comisiones sobre el precio final, quedan sujetos a las condiciones establecidas en los TyC. Podés volver a leerlos en tu perfil.'

export const mensajePagoOnlinePendiente = (fecha) =>
  `El pago online estará disponible próximamente. Para abonar el aviso${
    fecha ? `, con vigencia hasta el ${fecha},` : ''
  } comunicate con e-BuyMarket.`

const QUEDA_SIN_PAGAR_TEXTO =
  'La publicación queda en estado Sin Pagar y se publicará automáticamente cuando se confirme el pago.'

export const mensajeAvisoSeAbonaAlFinalizar = (monto, fecha) =>
  `Al finalizar, serás redireccionado a Mercado Pago para abonar $${monto}. La publicación queda en estado Sin Pagar y se publicará automáticamente cuando se confirme el pago.${
    fecha ? ` La misma quedará vigente hasta el ${fecha}.` : ''
  }`

export const mensajeAvisoSeAbonaAlGuardar = (monto) =>
  `Se guardarán los cambios y serás redireccionado a Mercado Pago para abonar $${monto}.

${QUEDA_SIN_PAGAR_TEXTO}`

export const EDICION_CON_AVISO_VIGENTE_TEXTO =
  'Los cambios se guardan y la publicación mantiene su estado y la vigencia del aviso que ya abonaste.'

export const EMAIL_MP_AYUDA_TEXTO =
  'El aviso se debita automáticamente cada mes, así que Mercado Pago necesita saber con qué cuenta vas a pagar. Tiene que ser el mail de una cuenta de Mercado Pago ya existente: vas a iniciar sesión con ésa para autorizar el débito.'

export const EMAIL_MP_INVALIDO_TEXTO = 'Escribí un mail válido, con arroba y dominio.'

export const ESPERANDO_PAGO_TEXTO =
  'Esta publicación está Sin Pagar. Pasará a estado Publicada cuando Mercado Pago confirme el pago del aviso.'

export const mensajeAvisoVence = (fecha) =>
  `El aviso vence el ${fecha}. Al vencer deberás abonar un nuevo aviso para volver a publicarla.`

export const mensajeAvisoVencido = (fecha) =>
  `El aviso venció el ${fecha}. Para volver a publicarla deberás abonar un nuevo aviso.`

export const mensajeAvisoProximoAVencer = (titulo) =>
  `El aviso de "${titulo}" está próximo a vencer. Al vencer deberás abonar un nuevo aviso para volver a publicarla.`

export const mensajeVigenciaAviso = (fecha) =>
  `Esta publicación ${fecha ? `vence el ${fecha}` : 'tiene vigencia mensual'}. Al vencer podrás volver a publicarla abonando un nuevo aviso.`

export const badgeAvisoVence = (texto) => `Aviso vence en ${texto}`

export const TIPO_PRODUCTO_PRODUCTOS = 'Productos'
export const TIPO_PRODUCTO_SERVICIOS = 'Servicios'
export const TIPO_PRODUCTO_VEHICULOS = 'Vehículos'
export const TIPO_PRODUCTO_SCRAP = 'Scrap'

export const ID_CATEGORIA_SERVICIOS = 1540
export const ID_CATEGORIA_VEHICULOS = 1743

export const mensajeConsultaWhatsapp = (titulo) =>
  `Hola, te consulto por la publicación "${titulo}" de e-BuyMarket.`

export const mensajeAvisoAbonado = (idPublicacion) =>
  `Tu publicación nro. ${idPublicacion} ya está publicada.`
